export default __webpack_public_path__ + "static/media/alert_search_loaded.2e2dbf27.png";